// 统一API导出 - 使用新的模块化结构
import { authApi } from './modules/auth';
import { cardsApi } from './modules/cards';
import { agentsApi } from './modules/agents';
import { adminApi } from './modules/admin';
import { userApi } from './modules/user';
import { tutorialsApi } from './modules/tutorials';
import { tutorialCategoriesApi } from './modules/tutorialCategories';
import httpClient from './http';
import { API_ENDPOINTS } from './config';
// 导出所有API模块
export default {
    // 认证相关 - 使用模块化API
    auth: authApi,
    // 卡密相关 - 使用模块化API
    cards: cardsApi,
    // 代理相关 - 使用模块化API
    agents: agentsApi,
    // 管理员相关 - 使用模块化API
    admin: adminApi,
    // 统计相关
    stats: {
        dashboard: () => httpClient.get(API_ENDPOINTS.STATS.DASHBOARD),
        recentActivities: () => httpClient.get(API_ENDPOINTS.STATS.RECENT_ACTIVITIES)
    },
    // 卡密类型相关
    cardTypes: {
        list: () => httpClient.get(API_ENDPOINTS.CARD_TYPES.LIST),
        create: (data) => httpClient.post(API_ENDPOINTS.CARD_TYPES.CREATE, data),
        update: (data) => httpClient.put(API_ENDPOINTS.CARD_TYPES.UPDATE, data),
        delete: (data) => httpClient.delete(API_ENDPOINTS.CARD_TYPES.DELETE, { data }),
        toggleStatus: (data) => httpClient.put(API_ENDPOINTS.CARD_TYPES.TOGGLE_STATUS, data)
    },
    // 激活日志相关
    logs: {
        list: (params) => httpClient.get(API_ENDPOINTS.LOGS.LIST, { params }),
        export: (params) => httpClient.get(API_ENDPOINTS.LOGS.EXPORT, { params }),
        stats: (params) => httpClient.get(API_ENDPOINTS.LOGS.STATS, { params })
    },
    // 系统日志相关
    systemLogs: {
        list: (params) => httpClient.get(API_ENDPOINTS.SYSTEM_LOGS.LIST, { params }),
        export: (params) => httpClient.get(API_ENDPOINTS.SYSTEM_LOGS.EXPORT, { params, responseType: 'blob' }),
        stats: () => httpClient.get(API_ENDPOINTS.SYSTEM_LOGS.STATS),
        clear: () => httpClient.post(API_ENDPOINTS.SYSTEM_LOGS.CLEAR),
        loginLogs: (params) => httpClient.get(API_ENDPOINTS.SYSTEM_LOGS.LOGIN_LOGS, { params })
    },
    // 设备管理相关
    deviceManagement: {
        list: (params) => httpClient.get(API_ENDPOINTS.DEVICE_MANAGEMENT.LIST, { params }),
        detail: (deviceId) => httpClient.get(`${API_ENDPOINTS.DEVICE_MANAGEMENT.DETAIL}&device_id=${deviceId}`),
        unbind: (data) => httpClient.post(API_ENDPOINTS.DEVICE_MANAGEMENT.UNBIND, data),
        stats: () => httpClient.get(API_ENDPOINTS.DEVICE_MANAGEMENT.STATS),
        updateRemark: (data) => httpClient.post(API_ENDPOINTS.DEVICE_MANAGEMENT.UPDATE_REMARK, data)
    },
    // 系统设置相关
    settings: {
        getAll: () => httpClient.get('/api/settings.html?action=get_all'),
        updateBasic: (data) => httpClient.put('/api/settings.html?action=update_basic', data),
        updateSecurity: (data) => httpClient.put('/api/settings.html?action=update_security', data),
        updateEmail: (data) => httpClient.put('/api/settings.html?action=update_email', data),
        testEmail: () => httpClient.post('/api/settings.html?action=test_email')
    },
    // 通知相关
    notifications: {
        list: (params) => httpClient.get('/api/notifications.html?action=list', { params }),
        markAsRead: (id) => httpClient.put('/api/notifications.html?action=mark_read', { id }),
        markAsUnread: (id) => httpClient.put('/api/notifications.html?action=mark_unread', { id }),
        markAllAsRead: () => httpClient.put('/api/notifications.html?action=mark_all_read'),
        delete: (id) => httpClient.delete('/api/notifications.html?action=delete', { data: { id } }),
        deleteAll: () => httpClient.delete('/api/notifications.html?action=delete_all')
    },
    // 个人资料相关
    profile: {
        update: (data) => httpClient.put('/api/profile.html?action=update', data),
        changePassword: (data) => httpClient.put('/api/profile.html?action=change_password', data),
        getStats: () => httpClient.get('/api/profile.html?action=stats'),
        getActivities: () => httpClient.get('/api/profile.html?action=activities')
    },
    // 财务报表相关
    reports: {
        getFinancial: (params) => httpClient.get('/api/reports.php?action=financial', { params }),
        exportFinancial: (params) => httpClient.get('/api/reports.php?action=export_financial', { params })
    },
    // 备份相关
    backup: {
        create: () => httpClient.post('/api/backup.html?action=create'),
        list: () => httpClient.get('/api/backup.html?action=list'),
        delete: (id) => httpClient.delete('/api/backup.html?action=delete', { data: { id } }),
        download: (filename) => httpClient.get(`/api/backup.html?action=download&file=${filename}`)
    },
    // 用户相关
    user: userApi,
    // 教程相关
    tutorials: tutorialsApi,
    tutorialCategories: tutorialCategoriesApi
};
// 导出HTTP客户端供高级使用
export { httpClient };
